"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditModeTogglePropTypes = exports.EditModeToggle = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../../UIElements/Icons/PetSure/Icon");
var _hooks = require("../../../../hooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EditModeToggle = _ref => {
  let {
    editMode = false,
    onEditModeChange = () => {},
    toggleButton = {
      customCssClass: '',
      editMode: {
        label: 'Cancel',
        icon: 'eye'
      },
      defaultMode: {
        label: 'Enable editing',
        icon: 'pencil'
      }
    },
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const [isEditing, setIsEditing] = (0, _react.useState)(editMode);
  const editableToggleButton = (0, _react.useRef)(null);
  (0, _hooks.useTracking)({
    elementRef: editableToggleButton,
    trackingProps: {
      label: 'Breed list selection',
      field: {
        inputType: 'button'
      }
    },
    customTrackingData,
    customTrackingEvents
  });
  const HandleEditModeChange = newState => {
    setIsEditing(newState);
    onEditModeChange(newState);
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    ref: editableToggleButton,
    type: "button",
    title: isEditing ? toggleButton.editMode.label : toggleButton.defaultMode.label,
    className: "editableToggleButton ".concat(toggleButton.customCssClass || 'button outline icon_only'),
    onClick: () => HandleEditModeChange(!isEditing)
  }, isEditing ? /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: toggleButton.editMode.icon
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, toggleButton.editMode.label)) : /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: toggleButton.defaultMode.icon
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, toggleButton.defaultMode.label)));
};
exports.EditModeToggle = EditModeToggle;
const EditModeTogglePropTypes = exports.EditModeTogglePropTypes = {
  editMode: _propTypes.default.bool,
  onEditModeChange: _propTypes.default.func,
  toggleButton: _propTypes.default.shape({
    customCssClass: _propTypes.default.string,
    editMode: _propTypes.default.shape({
      label: _propTypes.default.string,
      icon: _propTypes.default.string
    }),
    defaultMode: _propTypes.default.shape({
      label: _propTypes.default.string,
      icon: _propTypes.default.string
    })
  }),
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};
EditModeToggle.propTypes = EditModeTogglePropTypes;
var _default = exports.default = {
  EditModeToggle
};